<template>
  <div
    class="container"
    v-show="isShow"
    :style="{
      left: position.left - 492 + 'px',
      top: position.top - 213 + 'px'
    }"
    @click.stop
  >
    <div class="close" @click="isShow = false"></div>
    <div class="header-title">获得链接的人可以预览你的项目</div>
    <div class="copy-and-qr">
      <div class="copy-content">
        <div class="copy-url">{{address}}</div>
        <div :class="['copy-btn', hasCopy&&'has-copy']" @click="copyAddress">{{hasCopy?'复制成功':'复制链接'}}</div>
      </div>
      <div class="qr-content">
        <div class="popup">
          <qriously
            :value="address"
            :size="112"
            :padding="0"
          />
        </div>
      </div>
    </div>
    <ul class="list">
      <li
        class="item"
        v-for="(item, key) in list"
        :key="key"
      >
        <a
          class="item__link"
          :href="item.host + item.qs"
          target="_blank"
          @click="track(item)"
        >
          <div
            class="item__icon"
            :class="{[key]: true}"
            :style="{'background-image': `url(${item.icon})`}"
          ></div>
          <div>{{item.text}}</div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { encode } from 'qss';
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      isShow: false,
      shareUrl: '',
      position: {
        left: 0,
        top: 0,
      },
      address: '',
      hasCopy: false,
      list: {
        qq: {
          icon: '../../../../static/img/icon-qq.svg',
          host: 'https://connect.qq.com/widget/shareqq/index.html?',
          qs: '',
          text: 'QQ',
          qsDict: {
            url: '',
            showcount: 0,
            desc: '',
            summary: '',
            title: '',
            site: '来画',
            pics: '',
            style: 201,
            width: 39,
            height: 39
          }
        },
        qzone: {
          icon: '../../../../static/img/icon-qzone.svg',
          host: 'https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?',
          qs: '',
          text: 'QQ空间',
          qsDict: {
            url: '',
            showcount: 0,
            desc: '',
            summary: '',
            title: '',
            site: '来画',
            pics: '',
            style: 201,
            width: 39,
            height: 39
          }
        },
        weibo: {
          icon: '../../../../static/img/icon-weibo.svg',
          host: 'http://service.weibo.com/share/share.php?',
          qs: '',
          text: '微博',
          qsDict: {
            url: '',
            appkey: 'c3d7249c41de222a4412b4e610702803',
            title: '',
            pic: '',
            language: 'zh_cn'
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'WorksProjectId',
      'historyVersionList',
      'cooperationDraftId',
      'cooperationDraftOwnerId'
    ])
  },
  created () {
    this.$bus.on('share.show', ({ left, top }) => {
      this.$bus.emit('share.getQs', this)
      this.setPosition({ left, top });
      this.address = `${window.location.origin}/draftpreview/index.html?id=${window.draftId || this.WorksProjectId}`
      this.isShow = true;
    })
    this.$bus.on('share.hide', ({ left, top }) => {
      this.setPosition({ left: 0, top: 0 });
      this.isShow = false;
    })
  },
  mounted () {
    this.$parent.$el.addEventListener('click', () => {
      this.setPosition({ left: 0, top: 0 });
      this.isShow = false;
    });


    $(window).on('resize click', () => {
      this.isShow = false;
    })
  },
  methods: {
    track (item) {
      sensors.track('share', {
        author_id: '',
        author_name: '',
        business: '',
        content_duration: '',
        content_id: location.hash.slice(2),
        content_name: '',
        price_type: '',
        price: '',
        purpose: '',
        share_method: item.text,
        share_source: '编辑器-项目',
        share_type: '项目',
        template_id: this.$route.template || '',
        template_style: '',
        template_type: '',
      })
    },
    setPosition ({
      left,
      top
    } = {}) {
      this.position = {
        ...this.position,
        left,
        top
      };
    },
    toggle () {
      this.isShow = !this.isShow;
    },

    getShareUrl () {
      let origin = window.location.origin;
      let path = '/draftpreview/';
      let projectId = this.WorksProjectId;
      if (this.cooperationDraftOwnerId) {
        if (this.historyVersionList.length) {
          projectId = (this.historyVersionList[0] || {}).id + '&share=1';
        } else {
          projectId = window.location.hash.replace('#/', '') + '&cooperation=1';
        }
      }

      return origin + path + 'index.html?id=' + projectId;
    },
    getQs (params = {}) {
      this.shareUrl = this.getShareUrl();
      params = {
        ...params,
        url: this.shareUrl
      };
      this.handleQQ('qq', params);
      this.handleQQ('qzone', params);
      this.handleWeibo(params);
    },
    handleQQ (key, params) {
      let dict = this.list[key].qsDict;
      this.list[key].qsDict = {
        ...dict,
        title: params.title,
        desc: params.desc,
        summary: params.desc,
        pics: params.pic,
        url: params.url,
      }
      this.list[key].qs = encode(this.list[key].qsDict);
    },
    handleWeibo (params) {
      let dict = this.list.weibo.qsDict;
      this.list.weibo.qsDict = {
        ...dict,
        title: params.title,
        pic: params.pic,
        url: params.url,
      }
      this.list.weibo.qs = encode(this.list.weibo.qsDict);
    },
    copyAddress () {
      if (this.hasCopy) return;
      this.hasCopy = true;
      setTimeout(() => {
        this.hasCopy = false;
      }, 1000)
      let ok = this.copyToClipboard(this.address);
      if (!ok) {
        console.error('copy failed')
      }
    },
    copyToClipboard(text) {
      let suc = false
      try {
        navigator.clipboard.writeText(text);
      } catch (err) {
        suc = false
      }
      return suc;
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: absolute;
  width: 492px;
  height: 205px;
  z-index: 9999;
  border: 1px solid #E6E6E6;
  background: #fff;
  // box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);

  .close {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 13px;
    height: 13px;
    cursor: pointer;

    &::before {
      position: absolute;
      content: '';
      width: 17px;
      height: 1px;
      background-color: #9E9E9E;
      transform: rotate(45deg);
      top: 6px;
      left: -2px;
    }

    &::after {
      content: '';
      position: absolute;
      width: 17px;
      height: 1px;
      background-color: #9E9E9E;
      transform: rotate(-45deg);
      top: 6px;
      left: -2px;
    }
  }
}

.header-title {
  margin-top: 30px;
  text-align: center;
  font-size: 14px;
  color: #333333;
  font-weight: bold;
}

.copy-and-qr {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;

  .copy-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 357px;
    height: 40px;
    border-radius: 4px;
    border: 1px solid #E4E4E4;
    margin-right: 20px;
  }
  .copy-url {
    display: flex;
    align-items: center;
    width: 250px;
    height: 40px;
    padding: 0 10px;
    white-space: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;
    user-select: text !important;

    &::-webkit-scrollbar {
      display: none;
    }
  }
  .copy-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 40px;
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    background-color: #2F58FE;
    border-radius: 4px;
    cursor: pointer;
  }
  .has-copy {
    background-color: #5ACD4B;
  }

  .qr-content {
    position: relative;
    top: 0;
    left: 0;
    width: 40px;
    height: 40px;
    background: url(../../../../static/img/icon-qr.svg) no-repeat center;
    background-size: 40px 40px;

    &:hover {
      .popup {
        display: block;
      }
    }
  }
}

.list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 204px;
  margin: 16px auto 0;
}

.item {
  &__link {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    color: #333;
    text-decoration: none;
    cursor: pointer;

    &:visited {
      color: #333;
    }
  }
  &__icon {
    width: 30px;
    height: 30px;
    margin-bottom: 6px;
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center center;
  }
}

.popup {
  display: none;
  position: absolute;
  top: 0%;
  left: calc(100% + 20px);
  width: 116px;
  height: 116px;
  padding: 6px;
  background-color: #fff;
  box-shadow: 0px 2px 9px rgba(56, 58, 66, 0.17);

  > div {
    // vue-qriously 很难用
    transform-origin: 0 0;
    transform: scale(.94);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/exportDialog/share.vue